import React, { useState, useRef, useEffect } from 'react';
import {
  Box,
  Button,
  Paper,
  Popover,
  Typography,
  LinearProgress,
  IconButton,
  Divider,
  Stack,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
  Tooltip,
  TextField,
  Grid,
  SwipeableDrawer,
  Slider,
  CircularProgress,
} from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import ScreenShareIcon from '@mui/icons-material/ScreenShare';
import PauseIcon from '@mui/icons-material/Pause';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import WaveformVisualization from '../AudioControl/WaveformVisualization';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckIcon from '@mui/icons-material/Check';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesomeOutlined';
import StartIcon from '@mui/icons-material/StartOutlined';
import RestorePageOutlinedIcon from '@mui/icons-material/RestorePageOutlined';
import EjectOutlinedIcon from '@mui/icons-material/EjectOutlined';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import LinkIcon from '@mui/icons-material/Link';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { GMailIcon, WhatsAppIcon } from '../SvgIcon/SvgIcon';
import { WhatsappShareButton } from 'react-share';
import { useDispatch, useSelector, useStore } from 'react-redux';
import SummarizeDialog from './SummarizeDialog';
import { API_URL } from '../../config/apiUrl';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import axios from 'axios';
import {
  resetRecording,
  setCurrentRecording,
} from '../../redux/actions/currentRecording';
import { openSnackbar } from '../../redux/actions/snackbarAction';
import LoopIcon from '@mui/icons-material/Loop';
import { fetchUserCredits } from '../../redux/userSlice';
import copy from 'copy-to-clipboard';
import { isMobile, isTablet } from 'react-device-detect';
import { useNavigate, useLocation } from 'react-router-dom';
import { isTranscriptRoute, ROUTES } from '../../routes';
function AudioControl(props) {
  // React Router hooks
  const navigate = useNavigate();
  const location = useLocation();

  // Determine if on transcript view using route path
  const currentPath = location.pathname;
  const isTranscriptView = isTranscriptRoute(currentPath);

  const currentMeetingDetails = useSelector(
    state => state.currentMeetingDetails
  );

  const {
    paused,
    isRecording,
    manualPause,
    autoPaused,
    websocketConnection,
    audioControlDisabled,
    meetingTitle,
    meetingContext,
    stopped,
    isStarted,
    microPhoneList,
    content,
    isFinalizing,
    shouldOpenSummarizeDialog,
  } =
    Object.keys(props.meetingAPIDetails).length > 0
      ? props.meetingAPIDetails
      : currentMeetingDetails;

  // Always from Redux so loader shows during resume-wait (meetingAPIDetails may not include it)
  const resumeWaitingForServer = Boolean(currentMeetingDetails?.resumeWaitingForServer);
  const [activeMode, setActiveMode] = useState('mic');

  // const [isRecording, setIsRecording] = useState(false);
  const [audioData, setAudioData] = useState([]);
  const [micSource, setMicSource] = useState('Default Microphone');
  const [micPopoverAnchor, setMicPopoverAnchor] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [permission, setPermission] = useState(false);
  const [stopClick, setStopClick] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [resumeDialogOpen, setResumeDialogOpen] = useState(false);
  const [hoverDisplay, setHoverDisplay] = useState(false);
  const [openDeleteDialogue, setOpenDeleteDialogue] = useState(false);
  const [openRestoreDialog, setOpenRestoreDialog] = useState(false);
  const [openPermanentDeleteDialog, setOpenPermanentDeleteDialog] = useState(false);
  const [openShareDialog, setOpenShareDialog] = useState(false);
  const [shareUrl, setShareUrl] = useState('');
  const [isLoadingShare, setIsLoadingShare] = useState(false);
  const [copied, setCopied] = useState(false);
  const [lastSourceDialogOpen, setLastSourceDialogOpen] = useState(false);
  const [pendingSourceAction, setPendingSourceAction] = useState(null);

  const subject = encodeURIComponent('Check this out!');
  const body = encodeURIComponent(`Hey, take a look at this:\n\n${shareUrl}`);
  const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&su=${subject}&body=${body}`;

  const meetingTitleRef = useRef(meetingTitle);
  const dialogOpenedForStopRef = useRef(false);

  const dispatch = useDispatch();
  const store = useStore();
  const mediaRecorderRef = useRef(null);
  const streamRef = useRef(null);
  const {
    microphones,
    activeMicrophone,
    volume,
    microphoneError,
    selectMicrophone,
    isMicActive,
    isSystemActive,
    clearMicSpeaker,
  } = props;

  // Helper function to check if summary content exists
  const hasSummaryContent = summaryContext => {
    if (!summaryContext || typeof summaryContext !== 'string') return false;
    // Remove HTML tags, non-breaking spaces, and whitespace
    const stripped = summaryContext
      .replace(/<[^>]+>/g, '') // remove all HTML tags
      .replace(/&nbsp;/g, '') // remove non-breaking spaces
      .replace(/\s/g, ''); // remove all whitespace characters
    return stripped !== '';
  };

  // Check if transcript/content has real text
  const hasTranscriptContent = transcriptContent => {
    if (!transcriptContent || typeof transcriptContent !== 'string')
      return false;
    const stripped = transcriptContent
      .replace(/<[^>]+>/g, '') // remove HTML tags
      .replace(/&nbsp;/g, '') // remove non-breaking spaces
      .trim();
    return stripped.length > 0;
  };

  const handleSoftDelete = async meetingId => {

    props.setLoading(true);
    try {
      await axios.delete(`${API_URL}/api/history`, {
        headers: {
          Authorization: `Bearer ${props.transScriptSession}`,
          'Content-Type': 'application/json',
        },
        data: {
          recording_ids: [meetingId],
        },
      });
      dispatch(openSnackbar('success', 'Meeting Deleted.'));
      // setTriggerMeetingHistoryCall(true);
    } catch (err) {
      dispatch(
        openSnackbar('error', 'Something went wrong while deleting meeting.')
      );
      // Error while deleting meeting
      // setTriggerMeetingHistoryCall(true);
    } finally {
      props.setLoading(false);
      navigate(ROUTES.HISTORY);
    }
  };

  const handleRestore = async meetingId => {
    const url = `${API_URL}/api/history`;
    props.setLoading(true);
    try {
      await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${props.transScriptSession}`,
          'Content-Type': 'application/json',
        },
        data: {
          recording_ids: [meetingId],
          recover: true,
        },
      });
      dispatch(openSnackbar('success', 'Meeting restored successfully.'));
      props.setDetails({});
      if (props.setMeetingAPIDetails) {
        props.setMeetingAPIDetails({});
      }
      navigate(ROUTES.HISTORY);
    } catch (err) {
      dispatch(
        openSnackbar('error', 'Something went wrong while restoring meeting.')
      );
      // Error while restoring meeting
    } finally {
      props.setLoading(false);
    }
  };

  const handlePermanentDelete = async meetingId => {
    const url = `${API_URL}/api/history`;
    props.setLoading(true);
    try {
      await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${props.transScriptSession}`,
          'Content-Type': 'application/json',
        },
        data: {
          recording_ids: [meetingId],
          recover: false,
        },
      });
      dispatch(openSnackbar('success', 'Meeting permanently deleted.'));
      props.setDetails({});
      if (props.setMeetingAPIDetails) {
        props.setMeetingAPIDetails({});
      }
      navigate(ROUTES.BIN);
    } catch (err) {
      dispatch(
        openSnackbar(
          'error',
          'Something went wrong while permanently deleting meeting.'
        )
      );
      // Error while permanently deleting meeting
    } finally {
      props.setLoading(false);
    }
  };

  useEffect(() => {
    if (
      currentMeetingDetails.isStarted &&
      !currentMeetingDetails.stopped &&
      !(Object.keys(props.meetingAPIDetails).length > 0)
    ) {
      if (props.details?.isResume) return;
      if (isMicActive || isSystemActive) return;
      handleMicClick();
    }
  }, [
    currentMeetingDetails.isStarted,
    currentMeetingDetails.stopped,
    props.meetingAPIDetails,
    props.details?.isResume,
  ]);

  // Watch for flag to open summarize dialog (e.g., from inactivity stop)
  useEffect(() => {
    if (shouldOpenSummarizeDialog) {
      // Only open the summarize dialog when we have a valid meeting/recording id.
      const stateAfterFlag = store.getState();
      const latestMeetingId =
        stateAfterFlag?.currentMeetingDetails?.meeting_id || null;

      if (!latestMeetingId) {
        dialogOpenedForStopRef.current = false;
        setDialogOpen(false);
        dispatch(openSnackbar('warning', 'No recording or meeting ID was generated. Summary is unavailable.'));
      } else {
        dialogOpenedForStopRef.current = true;
        setDialogOpen(true);
      }
      dispatch(
        setCurrentRecording({
          shouldOpenSummarizeDialog: false,
          noRecordingExpected: false,
        })
      );
    }
  }, [shouldOpenSummarizeDialog, dispatch, store]);

  const isLastActiveSource = (togglingOff, otherActive) =>
    togglingOff && !otherActive && isRecording && !paused;

  const handleMicClick = async () => {
    if (isLastActiveSource(isMicActive, isSystemActive)) {
      setPendingSourceAction('mic');
      setLastSourceDialogOpen(true);
      return;
    }
    await props.startRecording({
      useMic: !isMicActive,
      useSpeaker: isSystemActive,
    });
  };

  const handleSystemClick = async () => {
    if (isLastActiveSource(isSystemActive, isMicActive)) {
      setPendingSourceAction('system');
      setLastSourceDialogOpen(true);
      return;
    }
    await props.startRecording({
      useMic: isMicActive,
      useSpeaker: !isSystemActive,
    });
  };

  const handleLastSourceProceed = async () => {
    setLastSourceDialogOpen(false);
    setPendingSourceAction(null);
    await props.startRecording({
      useMic: false,
      useSpeaker: false,
    });
  };

  const handleLastSourceCancel = () => {
    setLastSourceDialogOpen(false);
    setPendingSourceAction(null);
  };

  // const handleMicClick = async () => {
  //   await props.startRecording({
  //     useMic: true,
  //     useSpeaker: false,
  //     onlyAccess: true,
  //   });

  //   // setActiveMode("mic");
  //   // if (!permission) await getMicrophoneAccess();
  //   // if (mediaRecorderRef.current) {
  //   //   setAudioData([]);
  //   //   mediaRecorderRef.current.start();
  //   //   setIsRecording(true);
  //   // }
  // };

  // const handleSystemClick = async () => {
  //   await props.startRecording({
  //     useMic: false,
  //     useSpeaker: true,
  //     onlyAcces: false,
  //   });
  // };
  //   const handleSystemClick = () => {
  //     setActiveMode("system");

  //     // setIsRecording(true);
  //   };

  const handlePauseClick = () => {
    dispatch(
      setCurrentRecording({
        manualPause: true,
      })
    );
    props.pauseRecording();
    // if (mediaRecorderRef.current?.state === "recording") {
    //   mediaRecorderRef.current.pause();
    //   // setIsRecording(false);
    // }
  };

  const handleResume = () => {
    props.resumeRecording();
  };

  const handleStopClick = async () => {
    meetingTitleRef.current = meetingTitle;
    setStopClick(true);
    const noRecordingExpected = store.getState()?.currentMeetingDetails?.noRecordingExpected;
    // When server reported LOW_SIGNAL_AUDIO / NO_VOICE_ACTIVITY / etc., do not show loader; show snackbar without waiting.
    dispatch(
      setCurrentRecording({
        stopped: true,
        isRecording: false,
        isStarted: false,
        isFinalizing: !noRecordingExpected,
        lastAutoStopReason: 'manual',
      })
    );

    try {
      await props.stopRecording();
    } finally {
      clearMicSpeaker();

      const stateAfterStop = store.getState();
      const latestMeetingId =
        stateAfterStop?.currentMeetingDetails?.meeting_id || null;
      const stillNoRecordingExpected =
        stateAfterStop?.currentMeetingDetails?.noRecordingExpected;

      // Show same snackbar when no recording/meeting ID or when server reported no-speech scenario (no loader was shown).
      if (!latestMeetingId || stillNoRecordingExpected) {
        dialogOpenedForStopRef.current = false;
        setDialogOpen(false);
        dispatch(openSnackbar('warning', 'No recording or meeting ID was generated. Summary is unavailable.'));
      } else {
        dialogOpenedForStopRef.current = true;
        setDialogOpen(true);
      }
      if (props.transScriptSession) {
        dispatch(fetchUserCredits(props.transScriptSession));
      }
      dispatch(setCurrentRecording({ isFinalizing: false, noRecordingExpected: false }));
    }
  };

  const handleMicPopoverOpen = event => {
    setMicPopoverAnchor(event.currentTarget);
  };

  const handleMicPopoverClose = () => {
    setMicPopoverAnchor(null);
  };

  const handleShareClick = async event => {
    event.stopPropagation();
    setIsLoadingShare(true);
    setOpenShareDialog(true);

    try {
      const recordingId = currentRecordingId;

      if (!recordingId) {
        dispatch(
          openSnackbar(
            'error',
            'Unable to share this meeting. Meeting ID is missing.'
          )
        );
        setOpenShareDialog(false);
        return;
      }

      const response = await axios.post(
        `${API_URL}/api/share`,
        {
          recording_id: recordingId,
        },
        {
          headers: {
            Authorization: `Bearer ${props.transScriptSession}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data && response.data.url) {
        setShareUrl(response.data.url);
      } else {
        dispatch(openSnackbar('error', 'Failed to generate share URL.'));
        setOpenShareDialog(false);
      }
    } catch (error) {
      // Error sharing meeting
      dispatch(
        openSnackbar(
          'error',
          error.response?.data?.message ||
            'Something went wrong while sharing meeting.'
        )
      );
      setOpenShareDialog(false);
    } finally {
      setIsLoadingShare(false);
    }
  };

  const handleShareDialogClose = () => {
    setOpenShareDialog(false);
    setShareUrl('');
    setCopied(false);
  };

  const handleCopyUrl = () => {
    if (shareUrl) {
      const copySuccess = copy(shareUrl);
      if (copySuccess) {
        setCopied(true);
        dispatch(openSnackbar('success', 'URL copied to clipboard!'));
        setTimeout(() => setCopied(false), 2000);
      } else {
        dispatch(openSnackbar('error', 'Failed to copy URL.'));
      }
    }
  };

  const isMobileView = isMobile || isTablet;
  const openPopover = Boolean(micPopoverAnchor);
  const popoverId = openPopover ? 'microphone-popover' : undefined;
  const credits = useSelector(state => state.user.credits);
  const isResumeDisabled = credits <= 0;
  const isDeletedDetails = Boolean(
    props.isViewDetails &&
      (props.details?.includeDeleted ||
        props.details?.meetingDetails?.deleted ||
        props.details?.meetingDetails?.is_deleted)
  );
  const currentRecordingId =
    props.details?.meetingDetails?.id ||
    currentMeetingDetails?.meeting_id ||
    currentMeetingDetails?.id;
  const currentRecordingTitle =
    props.details?.meetingDetails?.title || meetingTitle || 'this meeting';

  const handleStartNew = async () => {
    if (currentMeetingDetails.isRecording) {
      dispatch(
        openSnackbar(
          'warning',
          'Please end the ongoing meeting first to create a new meeting.'
        )
      );
    } else {
      if (props.transScriptSession) {
        dispatch(fetchUserCredits(props.transScriptSession));
      }
      props.setDetails({});
      dispatch(resetRecording());
      props.resetTimer();
      props.setShowSummary(false);
      props.setSummaryContext('');
      props.resetAll();
      clearMicSpeaker();

      // Ensure main transcript view is shown immediately
      navigate(ROUTES.HOME);

      // Start the meeting directly
      setTimeout(() => {
        dispatch(setCurrentRecording({ isStarted: true }));
      }, 300);
    }
  };

  const handleOpenResumeDialog = () => {
    if (currentMeetingDetails.isRecording) {
      dispatch(
        openSnackbar(
          'warning',
          'Please end the ongoing meeting first to create a new meeting.'
        )
      );
      return;
    }

    if (currentRecordingId) {
      props.setDetails(prev => ({
        ...prev,
        meetingDetails: {
          ...(prev?.meetingDetails || {}),
          id: prev?.meetingDetails?.id || currentRecordingId,
          title: prev?.meetingDetails?.title || currentRecordingTitle,
        },
      }));
    }

    setResumeDialogOpen(true);
  };

  
  return (  
  // old code  here
    // <Box sx={{ display: 'flex', width: '100%' }}>
    //   <Paper
    //     elevation={0}
    //     sx={{
    //       display: 'flex',
    //       alignItems: 'center',
    //       justifyContent:
    //         !props.showSummary && !props.isViewDetails
    //           ? 'space-between'
    //           : 'end',
    //       p: 1,
    //       borderRadius: '8px',
    //       width: '100%',
    //       maxWidth: '100%',
    //       boxSizing: 'border-box',
    //       background: '#FAFBFD',
    //       border: 'solid 1px #e0e0e0',
    //     }}
    //   >
    //     {/* Left Controls */}
    //     {!props.showSummary && !props.isViewDetails && (
    //       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    //         <Paper
    //           elevation={0}
    //           className="mic-button"
    //           sx={{
    //             display: 'inline-flex',
    //             alignItems: 'center',
    //             borderRadius: '10px',
    //             bgcolor: isMicActive
    //               ? 'rgba(179, 209, 250, 0.20)'
    //               : 'var(--grey-100)',
    //             color: isMicActive ? 'var(--primary-300)' : 'text.primary',
    //             p: 0,
    //           }}
    //         >
    //           <Button
    //             onClick={handleMicClick}
    //             startIcon={<MicIcon />}
    //             sx={{
    //               color: 'inherit',
    //               bgcolor: 'transparent',
    //               boxShadow: 'none',
    //               textTransform: 'none',
    //               border: 'none',
    //               '&:hover': {
    //                 bgcolor: 'var(--primary-50)',
    //                 boxShadow: 'none',
    //                 border: 'none',
    //               },
    //             }}
    //             disabled={
    //               stopped || currentMeetingDetails?.audioControlDisabled
    //             }
    //           >
    //             Mic
    //           </Button>
    //           <Divider
    //             orientation="vertical"
    //             flexItem
    //             sx={{
    //               my: 1,
    //               borderColor: 'var(--grey-400)',
    //               opacity: 0.5,
    //             }}
    //           />
    //           <IconButton
    //             aria-describedby={popoverId}
    //             onClick={handleMicPopoverOpen}
    //             size="small"
    //             sx={{
    //               color: 'inherit',
    //               '&:hover': {
    //                 bgcolor: 'var(--primary-50)',
    //               },
    //               m: '0 4px',
    //             }}
    //             disabled={
    //               microphones.length === 0 ||
    //               currentMeetingDetails?.audioControlDisabled
    //             }
    //           >
    //             <KeyboardArrowDownIcon
    //               sx={{
    //                 transform: openPopover ? 'rotate(180deg)' : 'rotate(0deg)',
    //                 transition: 'transform 0.3s ease',
    //               }}
    //             />
    //           </IconButton>
    //         </Paper>
    //         <Button
    //           variant="outlined"
    //           startIcon={<ScreenShareIcon />}
    //           onClick={handleSystemClick}
    //           sx={{
    //             color: isSystemActive ? 'var(--primary-300)' : 'text.primary',
    //             bgcolor: isSystemActive
    //               ? 'rgba(179, 209, 250, 0.20)'
    //               : 'var(--grey-100)',
    //             borderRadius: '10px',
    //             textTransform: 'capitalize',
    //             border: 'none',
    //             height: '36.46px',
    //             '&:hover': {
    //               bgcolor: 'var(--primary-50)',
    //             },
    //             '&.Mui-disabled': {
    //               border: 'none',
    //             },
    //           }}
    //           disabled={stopped || currentMeetingDetails?.audioControlDisabled}
    //         >
    //           System
    //         </Button>
    //       </Box>
    //     )}

    //     {/* Waveform */}
    //     {isRecording && (
    //       <Box
    //         sx={{
    //           display: 'flex',
    //           flexGrow: 1,
    //           alignItems: 'center',
    //           justifyContent: 'center',
    //           gap: '3px',
    //           height: '35px',
    //           overflow: 'hidden',
    //           mx: 2,
    //           maxWidth: '400px',
    //         }}
    //       >
    //         {isRecording && !paused && (
    //           <WaveformVisualization
    //             isRecording={isRecording}
    //             micStream={props.streamRef.current}
    //           />
    //         )}
    //       </Box>
    //     )}

    //     {/* Right Controls */}

    //     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    //       {stopped || props.showSummary ? (
    //         <>
    //           {((!props.showSummary &&
    //             ((Object.keys(props.details).length > 0 &&
    //               props.details.meetingDetails.status !== 'full') ||
    //               !Object.keys(props.details).length > 0)) ||
    //             isTranscriptView) && (
    //             <Button
    //               variant="outlined"
    //               startIcon={<AutoAwesomeIcon />}
    //               color="primary"
    //               disabled={isFinalizing || content == ''}
    //               onClick={() => {
    //                 setDialogOpen(true);
    //                 meetingTitleRef.current = meetingTitle;
    //               }}
    //             >
    //               {hasSummaryContent(props.summaryContext)
    //                 ? 'Resummarize'
    //                 : 'Summarize'}
    //             </Button>
    //           )}
    //           {props.isViewDetails ? (
    //             <>
    //               <Tooltip title="Resume" arrow>
                    // <IconButton
                    //   size="small"
                    //   disabled={isResumeDisabled}
                    //   onClick={() => {
                    //     if (currentMeetingDetails.isRecording) {
                    //       dispatch(
                    //         openSnackbar(
                    //           'warning',
                    //           'Please end the ongoing meeting first to create a new meeting.'
                    //         )
                    //       );
                    //     } else {
                    //       setResumeDialogOpen(true);
                    //     }
                    //   }}
                    // >
                      // <EjectOutlinedIcon
                      //   sx={{
                      //     color: isResumeDisabled
                      //       ? 'text.disabled'
                      //       : 'text.primary',
                      //     transform: 'rotate(90deg)',
                      //   }}
                      // />
    //                 </IconButton>
    //               </Tooltip>
    //               <Tooltip title="Share" arrow>
                    // <IconButton size="small" onClick={handleShareClick}>
                    //   <ShareOutlinedIcon
                    //     fontSize="small"
                    //     sx={{ color: 'text.primary' }}
                    //   />
                    // </IconButton>
    //               </Tooltip>
    //               <Tooltip title="Delete" arrow>
                    // <IconButton
                    //   size="small"
                    //   onMouseEnter={() => {
                    //     setHoverDisplay(true);
                    //   }}
                    //   onMouseLeave={() => {
                    //     setHoverDisplay(false);
                    //   }}
                    //   onClick={() => {
                    //     setOpenDeleteDialogue(true);
                    //   }}
                    // >
                    //   <DeleteOutlineIcon
                    //     fontSize="small"
                    //     sx={{ color: 'error.main' }}
                    //   />
                    // </IconButton>
    //               </Tooltip>
    //             </>
    //           ) : (
    //             <Button
    //               variant="text"
    //               startIcon={<StartIcon />}
    //               color="default"
    //               disabled={isFinalizing}
                  // onClick={async () => {
                  //   if (currentMeetingDetails.isRecording) {
                  //     dispatch(
                  //       openSnackbar(
                  //         'warning',
                  //         'Please end the ongoing meeting first to create a new meeting.'
                  //       )
                  //     );
                  //   } else {
                  //     if (props.transScriptSession) {
                  //       dispatch(fetchUserCredits(props.transScriptSession));
                  //     }
                  //     props.setDetails({});
                  //     dispatch(resetRecording());
                  //     props.resetTimer();
                  //     props.setShowSummary(false);
                  //     props.setSummaryContext('');
                  //     props.resetAll();
                  //     clearMicSpeaker();

                  //     // Ensure main transcript view is shown immediately
                  //     if (props.setMenuSeleted)
                  //       navigate(ROUTES.HOME);

                  //     // Start the meeting directly
                  //     setTimeout(() => {
                  //       dispatch(setCurrentRecording({ isStarted: true }));
                  //     }, 300);
                  //   }
                  // }}
    //             >
    //               Start New
    //             </Button>
    //           )}
    //         </>
    //       ) : (
    //         <>
    //           {isRecording && !paused && (
    //             <Button
    //               variant="text"
    //               startIcon={<PauseCircleOutlineIcon />}
    //               onClick={handlePauseClick}
    //               sx={{ color: 'text.secondary' }}
    //               disabled={!isRecording}
    //             >
    //               Pause
    //             </Button>
    //           )}
    //           {paused && (
    //             <Button
    //               variant="text"
    //               startIcon={manualPause ? <EjectOutlinedIcon /> : <LoopIcon />}
    //               onClick={handleResume}
    //               sx={{
    //                 color: 'text.secondary',
    //                 '& .MuiSvgIcon-root': {
    //                   color: manualPause ? 'text.primary' : 'text.disabled',
    //                   transform: 'rotate(90deg)',
    //                 },
    //               }}
                  // disabled={
                  //   !manualPause ||
                  //   (!isMicActive && !isSystemActive) ||
                  //   audioControlDisabled
                  // }
    //             >
    //               {manualPause ? 'Resume' : 'Reconnecting...'}
    //             </Button>
    //           )}
    //           {/* {paused ? (
    //             <>
    //               <Button
    //                 variant="text"
    //                 startIcon={<PauseCircleOutlineIcon />}
    //                 onClick={handlePauseClick}
    //                 sx={{ color: "text.secondary" }}
    //                 disabled={!isRecording}
    //               >
    //                 Pause
    //               </Button>
    //             </>
    //           ) : (
    //             <Button
    //               variant="text"
    //               startIcon={
    //                 <EjectOutlinedIcon
    //                   sx={{ color: "text.primary", transform: "rotate(90deg)" }}
    //                 />
    //               }
    //               onClick={handlePauseClick}
    //               sx={{ color: "text.secondary" }}
    //             >
    //               Resume
    //             </Button>
    //           )} */}
    //           <Button
    //             variant="text"
    //             startIcon={<StopCircleIcon />}
    //             onClick={handleStopClick}
    //             color="error"
    //             disabled={
    //               !isRecording || currentMeetingDetails?.audioControlDisabled
    //             }
    //           >
    //             Stop
    //           </Button>
    //         </>
    //       )}
    //     </Box>
    //   </Paper>

    //   {/* Microphone Popover */}
    //   <Popover
    //     id={popoverId}
    //     open={openPopover}
    //     anchorEl={micPopoverAnchor}
    //     onClose={handleMicPopoverClose}
    //     anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
    //     transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    //     slotProps={{
    //       paper: {
    //         sx: {
    //           backgroundColor: '#3c4043',
    //           color: '#e8eaed',
    //           borderRadius: '12px',
    //           p: 2,
    //           mt: 1,
    //           width: '320px',
    //         },
    //       },
    //     }}
    //   >
    //     <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
    //       {microphones.map(mic => (
    //         <Box
    //           key={mic.deviceId}
    //           onClick={() => {
    //             selectMicrophone(mic.deviceId);
    //             handleMicPopoverClose();
    //           }}
    //           sx={{
    //             display: 'flex',
    //             alignItems: 'center',
    //             gap: 2,
    //             cursor: 'pointer',
    //           }}
    //         >
    //           {activeMicrophone?.deviceId === mic.deviceId && (
    //             <CheckIcon sx={{ color: '#8ab4f8' }} />
    //           )}
    //           <Box>
    //             <Typography
    //               sx={{
    //                 color:
    //                   activeMicrophone?.deviceId === mic.deviceId
    //                     ? '#8ab4f8'
    //                     : '#e8eaed',
    //                 fontWeight: '500',
    //               }}
    //             >
    //               {mic.label || 'Unnamed Microphone'}
    //             </Typography>
    //             {activeMicrophone?.deviceId === mic.deviceId && (
    //               <Typography variant="body2" sx={{ color: '#bdc1c6' }}>
    //                 System default
    //               </Typography>
    //             )}
    //           </Box>
    //         </Box>
    //       ))}

    //       {activeMicrophone && (
    //         <Box
    //           sx={{ display: 'flex', alignItems: 'center', gap: 2, pl: '2px' }}
    //         >
    //           <MicIcon sx={{ color: '#e8eaed' }} />
    //           <LinearProgress
    //             variant="determinate"
    //             value={volume}
    //             sx={{
    //               flexGrow: 1,
    //               height: 4,
    //               borderRadius: 2,
    //               backgroundColor: '#5f6368',
    //               '& .MuiLinearProgress-bar': {
    //                 backgroundColor: '#8ab4f8',
    //               },
    //             }}
    //           />
    //         </Box>
    //       )}
    //     </Box>
    //   </Popover>
      
    //   {/* Share Dialog - same as History page */}
    //   <Dialog
    //     open={openShareDialog}
    //     onClose={handleShareDialogClose}
    //     maxWidth="sm"
    //     fullWidth
    //     PaperProps={{
    //       sx: {
    //         borderRadius: 2,
    //       },
    //     }}
    //   >
    //     <DialogTitle>
    //       <Box display="flex" alignItems="center" gap={1}>
    //         <LinkIcon sx={{ color: 'primary.main' }} />
    //         <Typography variant="h6" component="span" fontWeight={600}>
    //           Share link
    //         </Typography>
    //         <IconButton
    //           aria-label="close"
    //           onClick={handleShareDialogClose}
    //           sx={{
    //             position: 'absolute',
    //             right: 8,
    //             top: 8,
    //             color: 'text.secondary',
    //           }}
    //           size="small"
    //         >
    //           <CloseIcon />
    //         </IconButton>
    //       </Box>
    //     </DialogTitle>
    //     <DialogContent>
    //       {isLoadingShare && !shareUrl ? (
    //         <Box display="flex" justifyContent="center" py={4}>
    //           <Typography variant="body2" color="text.secondary">
    //             Loading share URL...
    //           </Typography>
    //         </Box>
    //       ) : shareUrl ? (
    //         <Stack spacing={3}>
    //           {/* URL Section */}
    //           <Box>
    //             <Typography
    //               variant="caption"
    //               color="text.secondary"
    //               fontWeight={500}
    //               sx={{ mb: 1, display: 'block' }}
    //             >
    //               URL
    //             </Typography>
    //             <Box display="flex" gap={1}>
    //               <TextField
    //                 fullWidth
    //                 value={shareUrl}
    //                 variant="outlined"
    //                 size="small"
    //                 InputProps={{
    //                   readOnly: true,
    //                   sx: {
    //                     backgroundColor: 'var(--grey-50)',
    //                     fontSize: '14px',
    //                   },
    //                 }}
    //               />
    //               <Button
    //                 variant="contained"
    //                 color="primary"
    //                 onClick={handleCopyUrl}
    //                 startIcon={<ContentCopyIcon />}
    //                 sx={{
    //                   minWidth: '120px',
    //                   whiteSpace: 'nowrap',
    //                 }}
    //               >
    //                 {copied ? 'Copied!' : 'Copy link'}
    //               </Button>
    //             </Box>
    //           </Box>

    //           {/* Share Using Section */}
    //           <Box>
    //             <Typography
    //               variant="caption"
    //               color="text.secondary"
    //               fontWeight={500}
    //               sx={{ mb: 2, display: 'block' }}
    //             >
    //               Share using
    //             </Typography>
    //             <Grid container spacing={2}>
    //               <Grid item xs={4} sm={3}>
    //                 <WhatsappShareButton
    //                   url={shareUrl}
    //                   style={{
    //                     width: '100%',
    //                     display: 'flex',
    //                     flexDirection: 'column',
    //                     alignItems: 'center',
    //                     gap: 8,
    //                     padding: '12px',
    //                     border: '1px solid var(--grey-100)',
    //                     borderRadius: '8px',
    //                     backgroundColor: 'transparent',
    //                     cursor: 'pointer',
    //                     textDecoration: 'none',
    //                     transition: 'all 0.2s',
    //                   }}
    //                   onMouseEnter={e => {
    //                     e.currentTarget.style.backgroundColor =
    //                       'var(--grey-50)';
    //                   }}
    //                   onMouseLeave={e => {
    //                     e.currentTarget.style.backgroundColor = 'transparent';
    //                   }}
    //                 >
    //                   <WhatsAppIcon sx={{ fontSize: 32 }} />
    //                   <Typography variant="caption" color="text.primary">
    //                     WhatsApp
    //                   </Typography>
    //                 </WhatsappShareButton>
    //               </Grid>
    //               <Grid item xs={4} sm={3}>
    //                 <Box
    //                   component="div"
    //                   onClick={() => {
    //                     window.location.href = gmailLink;
    //                   }}
    //                   sx={{
    //                     width: '100%',
    //                     display: 'flex',
    //                     flexDirection: 'column',
    //                     alignItems: 'center',
    //                     gap: 1,
    //                     padding: '12px',
    //                     border: '1px solid var(--grey-100)',
    //                     borderRadius: '8px',
    //                     backgroundColor: 'transparent',
    //                     cursor: 'pointer',
    //                     transition: 'all 0.2s',
    //                     '&:hover': {
    //                       backgroundColor: 'var(--grey-50)',
    //                     },
    //                   }}
    //                 >
    //                   <GMailIcon sx={{ fontSize: 32, color: '#EA4335' }} />
    //                   <Typography variant="caption" color="text.primary">
    //                     Email
    //                   </Typography>
    //                 </Box>
    //               </Grid>
    //               <Grid item xs={4} sm={3}>
    //                 <Box
    //                   component="div"
    //                   onClick={e => {
    //                     e.stopPropagation();
    //                     const copySuccess = copy(shareUrl);
    //                     if (copySuccess) {
    //                       dispatch(
    //                         openSnackbar(
    //                           'success',
    //                           'URL copied! You can paste it into Instagram.'
    //                         )
    //                       );
    //                       window.open('https://www.instagram.com/', '_blank');
    //                     } else {
    //                       dispatch(
    //                         openSnackbar('error', 'Failed to copy URL.')
    //                       );
    //                     }
    //                   }}
    //                   sx={{
    //                     width: '100%',
    //                     display: 'flex',
    //                     flexDirection: 'column',
    //                     alignItems: 'center',
    //                     gap: 1,
    //                     padding: '12px',
    //                     border: '1px solid var(--grey-100)',
    //                     borderRadius: '8px',
    //                     backgroundColor: 'transparent',
    //                     cursor: 'pointer',
    //                     transition: 'all 0.2s',
    //                     '&:hover': {
    //                       backgroundColor: 'var(--grey-50)',
    //                     },
    //                   }}
    //                 >
    //                   <Box
    //                     component="svg"
    //                     sx={{
    //                       width: 32,
    //                       height: 32,
    //                       viewBox: '0 0 24 24',
    //                       fill: 'url(#instagram-gradient)',
    //                     }}
    //                   >
    //                     <defs>
    //                       <linearGradient
    //                         id="instagram-gradient"
    //                         x1="0%"
    //                         y1="0%"
    //                         x2="100%"
    //                         y2="100%"
    //                       >
    //                         <stop offset="0%" stopColor="#f58529" />
    //                         <stop offset="50%" stopColor="#dd2a7b" />
    //                         <stop offset="100%" stopColor="#8134af" />
    //                       </linearGradient>
    //                     </defs>
    //                     <path d="M7 2C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5H7zm0 2h10c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3zm10 1a1 1 0 100 2 1 1 0 000-2zM12 7a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6z" />
    //                   </Box>
    //                   <Typography variant="caption" color="text.primary">
    //                     Instagram
    //                   </Typography>
    //                 </Box>
    //               </Grid>
    //             </Grid>
    //           </Box>
    //         </Stack>
    //       ) : (
    //         <Box display="flex" justifyContent="center" py={4}>
    //           <Typography variant="body2" color="text.secondary">
    //             Unable to generate share URL. Please try again.
    //           </Typography>
    //         </Box>
    //       )}
    //     </DialogContent>
    //   </Dialog>
    //   <SummarizeDialog
    //     open={dialogOpen}
    //     meetingTitle={meetingTitle}
    //     meetingContext={currentMeetingDetails.meetingContext}
    //     setMeetingAPIDetails={props.setMeetingAPIDetails}
    //     isMeetingAPIData={Object.keys(props.meetingAPIDetails).length > 0}
    //     onClose={() => setDialogOpen(false)}
    //     onSubmit={async () => {
    //       // First generate MOM, then update title so success messages are in order
    //       await props.handleSumbit(setDialogOpen);
    //       await props.handleTitleUpdate(meetingTitleRef);
    //     }}
    //     loading={props.loading}
    //   />
    //   <Dialog
    //     open={resumeDialogOpen}
    //     onClose={() => setResumeDialogOpen(false)}
    //     maxWidth="xs"
    //     fullWidth
    //   >
    //     <DialogTitle>
    //       <Typography
    //         variant="subtitle1"
    //         component={'span'}
    //         color="text.primary"
    //       >
    //         Are you sure you want to continue?
    //       </Typography>
    //     </DialogTitle>
    //     <DialogContent>
    //       <Typography variant="body2" color="text.primary">
    //         This will start a new meeting from where you left off.
    //       </Typography>
    //     </DialogContent>
    //     <DialogActions>
    //       <Button
    //         onClick={() => {
    //           setResumeDialogOpen(false);
    //         }}
    //       >
    //         Cancel
    //       </Button>
    //       <Button
    //         color="primary"
    //         variant="contained"
    //         onClick={async () => {
    //           props.resetAll();
    //           props.setLoading(true);
    //           props.setDetails(prev => ({
    //             ...prev,
    //             isResume: true,
    //             isDetailsView: false,
    //           }));
    //           navigate(ROUTES.HOME);
    //           setResumeDialogOpen(false);
    //           if (!isMicActive) {
    //             await handleMicClick();
    //           }
    //         }}
    //       >
    //         Resume
    //       </Button>
    //     </DialogActions>
    //   </Dialog>
    //   <Dialog
    //     open={openDeleteDialogue}
    //     onClose={() => setOpenDeleteDialogue(false)}
    //     maxWidth="xs"
    //     fullWidth
    //   >
    //     <DialogTitle>
    //       <Typography
    //         variant="subtitle1"
    //         component={'span'}
    //         color="text.primary"
    //       >
    //         Are you sure you want to continue?
    //       </Typography>
    //     </DialogTitle>
    //     <DialogContent>
    //       <Typography variant="body2" color="text.primary">
    //         {/* {`${meeting?.title} will be deleted.`} */}
    //         {
    //           <>
    //             <strong>{props.details.meetingDetails?.title}</strong> will be
    //             deleted.
    //           </>
    //         }
    //       </Typography>
    //     </DialogContent>
    //     <DialogActions>
    //       <Button
    //         onClick={() => {
    //           setOpenDeleteDialogue(false);
    //         }}
    //       >
    //         Cancel
    //       </Button>
    //       <Button
    //         color="error"
    //         variant="contained"
    //         onClick={() => {
    //           handleSoftDelete(props.details.meetingDetails.id);
    //           setOpenDeleteDialogue(false);
    //         }}
    //       >
    //         DELETE
    //       </Button>
    //     </DialogActions>
    //   </Dialog>
    // </Box>
// code ends here
   <Box 
   sx={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
        {/* // DESKTOP VIEW (Original Horizontal Layout) */}
      {!isMobileView && (
        <Paper
          elevation={0}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent:
              !props.showSummary && !props.isViewDetails
                ? 'space-between'
                : 'end',
            p: 1,
            borderRadius: '8px',
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
            background: '#FAFBFD',
            border: 'solid 1px #e0e0e0',
          }}
        >
          {/* Left Controls */}
          {!props.showSummary && !props.isViewDetails && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Paper
                elevation={0}
                className="mic-button"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  borderRadius: '10px',
                  bgcolor: isMicActive
                    ? 'rgba(179, 209, 250, 0.20)'
                    : 'var(--grey-100)',
                  color: isMicActive ? 'var(--primary-300)' : 'text.primary',
                  p: 0,
                }}
              >
                <Button
                  onClick={handleMicClick}
                  startIcon={<MicIcon />}
                  sx={{
                    color: 'inherit',
                    bgcolor: 'transparent',
                    boxShadow: 'none',
                    textTransform: 'none',
                    border: 'none',
                    '&:hover': {
                      bgcolor: 'var(--primary-50)',
                      boxShadow: 'none',
                      border: 'none',
                    },
                  }}
                  disabled={
                    stopped || currentMeetingDetails?.audioControlDisabled
                  }
                >
                  Mic
                </Button>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    my: 1,
                    borderColor: 'var(--grey-400)',
                    opacity: 0.5,
                  }}
                />
                <IconButton
                  aria-describedby={popoverId}
                  onClick={handleMicPopoverOpen}
                  size="small"
                  sx={{
                    color: 'inherit',
                    '&:hover': {
                      bgcolor: 'var(--primary-50)',
                    },
                    m: '0 4px',
                  }}
                  disabled={
                    microphones.length === 0 ||
                    currentMeetingDetails?.audioControlDisabled
                  }
                >
                  <KeyboardArrowDownIcon
                    sx={{
                      transform: openPopover ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'transform 0.3s ease',
                    }}
                  />
                </IconButton>
              </Paper>
              <Button
                variant="outlined"
                startIcon={<ScreenShareIcon />}
                onClick={handleSystemClick}
                sx={{
                  color: isSystemActive ? 'var(--primary-300)' : 'text.primary',
                  bgcolor: isSystemActive
                    ? 'rgba(179, 209, 250, 0.20)'
                    : 'var(--grey-100)',
                  borderRadius: '10px',
                  textTransform: 'capitalize',
                  border: 'none',
                  height: '36.46px',
                  '&:hover': {
                    bgcolor: 'var(--primary-50)',
                  },
                  '&.Mui-disabled': {
                    border: 'none',
                  },
                }}
                disabled={stopped || currentMeetingDetails?.audioControlDisabled}
              >
                System
              </Button>
            </Box>
          )}

        {/* Waveform */}
        {isRecording && (
          <Box
            sx={{
              display: 'flex',
              flexGrow: 1,
              alignItems: 'center',
              justifyContent: 'center',
              gap: '3px',
              height: '35px',
              overflow: 'hidden',
              mx: 2,
              maxWidth: '400px',
            }}
          >
            {isRecording && !paused && (
              <WaveformVisualization
                isRecording={isRecording}
                micStream={props.streamRef.current}
              />
            )}
          </Box>
        )}

        {/* Right Controls */}

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {(stopped || props.showSummary || props.hasSummary) && !currentMeetingDetails.isRecording ? (
            <>
              {props.isViewDetails &&
                !isDeletedDetails &&
                (isTranscriptView ||
                  props.isViewDetails ||
                  (!props.showSummary &&
                    (isTranscriptView ||
                      currentPath.startsWith('/transcribe/meeting/')))) && (
                <Button
                  variant="outlined"
                  startIcon={<AutoAwesomeIcon />}
                  color="primary"
                  disabled={isFinalizing || !hasTranscriptContent(content)}
                  onClick={() => {
                    setDialogOpen(true);
                    meetingTitleRef.current = meetingTitle;
                  }}
                >
                  {hasSummaryContent(props.summaryContext)
                    ? 'Resummarize'
                    : 'Summarize'}
                </Button>
              )}

              {props.isViewDetails ? (
                isDeletedDetails ? (
                  <>
                    <Tooltip title="Restore" arrow>
                      <IconButton
                        size="small"
                        onClick={() => setOpenRestoreDialog(true)}
                      >
                        <RestorePageOutlinedIcon
                          // fontSize="small"
                          sx={{ color: 'primary.main' }}
                        />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Permanently Delete" arrow>
                      <IconButton
                        size="small"
                        onClick={() => setOpenPermanentDeleteDialog(true)}
                      >
                        <DeleteOutlineIcon  
                          // fontSize="small"
                          sx={{ color: 'error.main' }}
                        />
                      </IconButton>
                    </Tooltip>
                  </>
                ) : isRecording ? (
                  <>
                    {!paused && (
                      <Button
                        variant="text"
                        startIcon={<PauseCircleOutlineIcon />}
                        onClick={handlePauseClick}
                        sx={{ color: 'text.secondary' }}
                        disabled={!isRecording}
                      >
                        Pause
                      </Button>
                    )}
                    {paused && (
                      <Button
                        variant="text"
                        startIcon={
                          resumeWaitingForServer ? (
                            <Box sx={{ display: 'inline-flex', width: 20, height: 20, alignItems: 'center', justifyContent: 'center' }}>
                              <CircularProgress size={18} color="inherit" sx={{ display: 'block' }} />
                            </Box>
                          ) : manualPause || autoPaused ? (
                            <EjectOutlinedIcon />
                          ) : (
                            <LoopIcon />
                          )
                        }
                        onClick={handleResume}
                        sx={{
                          color: 'text.secondary',
                          '& .MuiSvgIcon-root': {
                            color: manualPause || autoPaused ? 'text.primary' : 'text.disabled',
                            transform: 'rotate(90deg)',
                          },
                        }}
                        disabled={
                          resumeWaitingForServer ||
                          (!manualPause && !autoPaused) ||
                          (!isMicActive && !isSystemActive) ||
                          audioControlDisabled
                        }
                      >
                        {resumeWaitingForServer ? 'Waiting...' : manualPause || autoPaused ? 'Resume' : 'Reconnecting...'}
                      </Button>
                    )}
                    <Button
                      variant="text"
                      startIcon={<StopCircleIcon />}
                      onClick={handleStopClick}
                      color="error"
                      disabled={
                        !isRecording || currentMeetingDetails?.audioControlDisabled
                      }
                    >
                      Stop
                    </Button>
                  </>
                ) : (
                  <>
                    <Tooltip title="Resume" arrow>
                      <IconButton
                        size="small"
                        disabled={isResumeDisabled}
                        onClick={handleOpenResumeDialog}
                      >
                        <EjectOutlinedIcon
                          sx={{
                            color: isResumeDisabled
                              ? 'text.disabled'
                              : 'text.primary',
                            transform: 'rotate(90deg)',
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Share" arrow>
                      <IconButton size="small" onClick={handleShareClick}>
                        <ShareOutlinedIcon
                          fontSize="small"
                          sx={{ color: 'text.primary' }}
                        />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete" arrow>
                      <IconButton
                        size="small"
                        onMouseEnter={() => {
                          setHoverDisplay(true);
                        }}
                        onMouseLeave={() => {
                          setHoverDisplay(false);
                        }}
                        onClick={() => {
                          setOpenDeleteDialogue(true);
                        }}
                      >
                        <DeleteOutlineIcon
                          fontSize="small"
                          sx={{ color: 'error.main' }}
                        />
                      </IconButton>
                    </Tooltip>
                  </>
                )
              ) : (
                <>
                  <Button
                    variant="text"
                    startIcon={<StartIcon />}
                    color="default"
                    disabled={isFinalizing}
                    onClick={handleStartNew}
                  >
                    Start New
                  </Button>
                  {!isDeletedDetails &&
                    (isTranscriptView ||
                      props.isViewDetails ||
                      (!props.showSummary &&
                        (isTranscriptView ||
                          currentPath.startsWith('/transcribe/meeting/')))) && (
                    <Button
                      variant="outlined"
                      startIcon={<AutoAwesomeIcon />}
                      color="primary"
                      disabled={isFinalizing || !hasTranscriptContent(content)}
                      onClick={() => {
                        setDialogOpen(true);
                        meetingTitleRef.current = meetingTitle;
                      }}
                    >
                      {hasSummaryContent(props.summaryContext)
                        ? 'Resummarize'
                        : 'Summarize'}
                    </Button>
                  )}
                  <Tooltip title="Resume" arrow>
                    <IconButton
                      size="small"
                      disabled={isResumeDisabled}
                      onClick={handleOpenResumeDialog}
                    >
                      <EjectOutlinedIcon
                        sx={{
                          color: isResumeDisabled
                            ? 'text.disabled'
                            : 'text.primary',
                          transform: 'rotate(90deg)',
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Share" arrow>
                    <IconButton size="small" onClick={handleShareClick}>
                      <ShareOutlinedIcon
                        fontSize="small"
                        sx={{ color: 'text.primary' }}
                      />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete" arrow>
                    <IconButton
                      size="small"
                      onMouseEnter={() => {
                        setHoverDisplay(true);
                      }}
                      onMouseLeave={() => {
                        setHoverDisplay(false);
                      }}
                      onClick={() => {
                        setOpenDeleteDialogue(true);
                      }}
                    >
                      <DeleteOutlineIcon
                        fontSize="small"
                        sx={{ color: 'error.main' }}
                      />
                    </IconButton>
                  </Tooltip>
                </>
              )}
            </>
          ) : (
            <>
              {isRecording && !paused && (
                <Button
                  variant="text"
                  startIcon={<PauseCircleOutlineIcon />}
                  onClick={handlePauseClick}
                  sx={{ color: 'text.secondary' }}
                  disabled={!isRecording}
                >
                  Pause
                </Button>
              )}
              {paused && (
                <Button
                  variant="text"
                  startIcon={
                    resumeWaitingForServer ? (
                      <Box sx={{ display: 'inline-flex', width: 20, height: 20, alignItems: 'center', justifyContent: 'center' }}>
                        <CircularProgress size={18} color="inherit" sx={{ display: 'block' }} />
                      </Box>
                    ) : manualPause || autoPaused ? (
                      <EjectOutlinedIcon />
                    ) : (
                      <LoopIcon />
                    )
                  }
                  onClick={handleResume}
                  sx={{
                    color: 'text.secondary',
                    '& .MuiSvgIcon-root': {
                      color: manualPause || autoPaused ? 'text.primary' : 'text.disabled',
                      transform: 'rotate(90deg)',
                    },
                  }}
                  disabled={
                    resumeWaitingForServer ||
                    (!manualPause && !autoPaused) ||
                    (!isMicActive && !isSystemActive) ||
                    audioControlDisabled
                  }
                >
                  {resumeWaitingForServer ? 'Waiting...' : manualPause || autoPaused ? 'Resume' : 'Reconnecting...'}
                </Button>
              )}
              {/* {paused ? (
                <>
                  <Button
                    variant="text"
                    startIcon={<PauseCircleOutlineIcon />}
                    onClick={handlePauseClick}
                    sx={{ color: "text.secondary" }}
                    disabled={!isRecording}
                  >
                    Pause
                  </Button>
                </>
              ) : (
                <Button
                  variant="text"
                  startIcon={
                    <EjectOutlinedIcon
                      sx={{ color: "text.primary", transform: "rotate(90deg)" }}
                    />
                  }
                  onClick={handlePauseClick}
                  sx={{ color: "text.secondary" }}
                >
                  Resume
                </Button>
              )} */}
                <Button
                  variant="text"
                  startIcon={<StopCircleIcon />}
                  onClick={handleStopClick}
                  color="error"
                  disabled={
                    !isRecording || currentMeetingDetails?.audioControlDisabled
                  }
                >
                  Stop
                </Button>
              </>
            )}
          </Box>
        </Paper>
      )}
     
      {isMobileView && (
        <Paper
          elevation={0}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '16px 16px 8px 16px',
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
            background: '#FAFBFD',
            borderTop: 'solid 1px #e0e0e0',
            position: 'fixed',
            bottom: 0,
            left: 0,
            zIndex: 1000,
            gap: 1,
          }}
        >
          {isRecording && !paused && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '30px',
                overflow: 'hidden',
                mb: 0.5,
              }}
            >
              <WaveformVisualization
                isRecording={isRecording}
                micStream={props.streamRef.current}
              />
            </Box>
          )}

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              width: '100%',
            }} >
            {!(!stopped && !props.showSummary) && !props.isViewDetails && (
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'var(--primary-500)',
                  fontWeight: 600,
                  fontSize: '16px',
                  lineHeight: 1,
                  pointerEvents: 'none',
                  minWidth: 0,
                }}
              >
                {props.formatTime ? props.formatTime(props.recordingTime) : '00:00:00'}
              </Box>
            )}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: (currentMeetingDetails.isRecording || (!stopped && !props.showSummary)) ? 'center' : (props.isViewDetails ? 'center' : 'flex-end'),
                gap: (currentMeetingDetails.isRecording || (!stopped && !props.showSummary)) ? '50px' : (props.isViewDetails ? '50px' : '24px'),
                flex: 1,
              }}
            >
              {/* Stopped / history / summary — show Pause/Stop when meeting is actively recording (e.g. after resume) */}
              {(stopped || props.showSummary) && !currentMeetingDetails.isRecording ? (
                <>
                  {props.isViewDetails ? (
                    isDeletedDetails ? (
                      <>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                          <IconButton
                            onClick={() => setOpenRestoreDialog(true)}
                            sx={{
                              bgcolor: 'var(--grey-100)',
                              color: 'primary.main',
                              width: 40,
                              height: 40,
                              '&:hover': { bgcolor: 'var(--grey-200)' },
                            }}
                          >
                            <RestorePageOutlinedIcon sx={{ fontSize: 20 }} />
                          </IconButton>
                          <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, fontSize: '0.7rem' }}>
                            Restore
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                          <IconButton
                            onClick={() => setOpenPermanentDeleteDialog(true)}
                            sx={{
                              bgcolor: '#ffcdd2',
                              color: '#d32f2f',
                              width: 40,
                              height: 40,
                              '&:hover': { bgcolor: '#ef9a9a' },
                            }}
                          >
                            <DeleteOutlineIcon sx={{ fontSize: 20 }} />
                          </IconButton>
                          <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, fontSize: '0.7rem' }}>
                            Permanently Delete
                          </Typography>
                        </Box>
                      </>
                    ) : (
                      <>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            gap: 2.5,
                          }}
                        >
                          {/* Summarize Button */}
                          {!isDeletedDetails &&
                            (isTranscriptView ||
                              props.isViewDetails ||
                              (!props.showSummary &&
                                (isTranscriptView ||
                                  currentPath.startsWith('/transcriber/meeting/')))) ? (
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                              <IconButton
                                disabled={isFinalizing || !hasTranscriptContent(content)}
                                onClick={() => {
                                  setDialogOpen(true);
                                  meetingTitleRef.current = meetingTitle;
                                }}
                                sx={{
                                  bgcolor: 'var(--grey-100)',
                                  color: 'primary.main',
                                  width: 40,
                                  height: 40,
                                  '&:hover': { bgcolor: 'var(--grey-200)' },
                                }}
                              >
                                <AutoAwesomeIcon sx={{ fontSize: 20 }} />
                              </IconButton>
                              <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, fontSize: '0.7rem' }}>
                                {hasSummaryContent(props.summaryContext) ? 'Resummarize' : 'Summarize'}
                              </Typography>
                            </Box>
                          ) : null}

                          {/* Play / Pause with timer below */}
                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', bottom: 6 }}>
                            <IconButton
                              disabled={isResumeDisabled}
                              onClick={handleOpenResumeDialog}
                              sx={{
                                width: 40,
                                height: 40,
                                bgcolor: 'primary.main',
                                color: 'white',
                                boxShadow: '0px 3px 8px rgba(0,0,0,0.2)',
                                '&:hover': { bgcolor: 'primary.dark' },
                                mb: 0.5,
                              }}
                            >
                              <GraphicEqIcon sx={{ fontSize: 30 }} />
                            </IconButton>
                            <Typography
                              variant="body2"
                              sx={{
                                color: 'text.primary',
                                fontWeight: 600,
                                fontSize: '12px',
                                fontVariantNumeric: 'tabular-nums',
                                mt: 0.5,
                              }}
                            >
                              {props.formatTime ? props.formatTime(props.recordingTime) : '00:00:00'}
                            </Typography>
                          </Box>

                          {/* Delete */}
                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5, ml: '10px' }}>
                            <IconButton
                              onMouseEnter={() => setHoverDisplay(true)}
                              onMouseLeave={() => setHoverDisplay(false)}
                              onClick={() => setOpenDeleteDialogue(true)}
                              sx={{
                                bgcolor: '#ffcdd2',
                                color: '#d32f2f',
                                width: 40,
                                height: 40,
                                '&:hover': { bgcolor: '#ef9a9a' },
                              }}
                            >
                              <DeleteOutlineIcon sx={{ fontSize: 20 }} />
                            </IconButton>
                            <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, fontSize: '0.7rem' }}>
                              Delete
                            </Typography>
                          </Box>
                        </Box>
                      </>
                    )
                  ) : (
                    <>
                      {/* Start New */}
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                        <IconButton
                          disabled={isFinalizing}
                          onClick={handleStartNew}
                          sx={{
                            width: 40,
                            height: 40,
                            bgcolor: 'primary.main',
                            color: 'white',
                            boxShadow: '0px 3px 8px rgba(0,0,0,0.2)',
                            '&:hover': { bgcolor: 'primary.dark' },
                          }}
                        >
                          <StartIcon sx={{ fontSize: 30 }} />
                        </IconButton>
                        <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, fontSize: '0.7rem' }}>
                          Start New
                        </Typography>
                      </Box>

                      {/* Summarize / Resummarize */}
                      {!isDeletedDetails &&
                        (isTranscriptView ||
                          props.isViewDetails ||
                          (!props.showSummary &&
                            (isTranscriptView ||
                              currentPath.startsWith('/transcriber/meeting/')))) ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                          <IconButton
                            disabled={isFinalizing || !hasTranscriptContent(content)}
                            onClick={() => {
                              setDialogOpen(true);
                              meetingTitleRef.current = meetingTitle;
                            }}
                            sx={{
                              bgcolor: 'var(--grey-100)',
                              color: 'primary.main',
                              width: 40,
                              height: 40,
                              '&:hover': { bgcolor: 'var(--grey-200)' },
                            }}
                          >
                            <AutoAwesomeIcon sx={{ fontSize: 20 }} />
                          </IconButton>
                          <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, fontSize: '0.7rem' }}>
                            {hasSummaryContent(props.summaryContext) ? 'Resummarize' : 'Summarize'}
                          </Typography>
                        </Box>
                      ) : null}

                      {/* Resume */}
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                        <IconButton
                          disabled={isResumeDisabled}
                          onClick={handleOpenResumeDialog}
                          sx={{
                            bgcolor: 'var(--grey-100)',
                            color: isResumeDisabled ? 'text.disabled' : 'text.primary',
                            width: 40,
                            height: 40,
                            '&:hover': { bgcolor: 'var(--grey-200)' },
                          }}
                        >
                          <EjectOutlinedIcon sx={{ fontSize: 20, transform: 'rotate(90deg)' }} />
                        </IconButton>
                        <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, fontSize: '0.7rem' }}>
                          Resume
                        </Typography>
                      </Box>

                      {/* Share */}
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                        <IconButton
                          onClick={handleShareClick}
                          sx={{
                            bgcolor: 'var(--grey-100)',
                            color: 'text.primary',
                            width: 40,
                            height: 40,
                            '&:hover': { bgcolor: 'var(--grey-200)' },
                          }}
                        >
                          <ShareOutlinedIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                        <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, fontSize: '0.7rem' }}>
                          Share
                        </Typography>
                      </Box>

                      {/* Delete */}
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                        <IconButton
                          onMouseEnter={() => setHoverDisplay(true)}
                          onMouseLeave={() => setHoverDisplay(false)}
                          onClick={() => setOpenDeleteDialogue(true)}
                          sx={{
                            bgcolor: '#ffcdd2',
                            color: '#d32f2f',
                            width: 40,
                            height: 40,
                            '&:hover': { bgcolor: '#ef9a9a' },
                          }}
                        >
                          <DeleteOutlineIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                        <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, fontSize: '0.7rem' }}>
                          Delete
                        </Typography>
                      </Box>
                    </>
                  )}
                </>
              ) : (
                <>
                  {/* Mic settings */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                    <IconButton
                      onClick={handleMicPopoverOpen}
                      disabled={stopped || currentMeetingDetails?.audioControlDisabled}
                      sx={{
                        bgcolor: 'var(--grey-100)',
                        color: 'text.primary',
                        width: 40,
                        height: 40,
                        '&:hover': { bgcolor: 'var(--grey-200)' },
                      }}
                    >
                      <MicIcon sx={{ fontSize: 20 }} className={isRecording ? 'recording' : ''} />
                    </IconButton>
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, fontSize: '0.7rem' }}>
                      Mic
                    </Typography>
                  </Box>

                  {/* Play / Pause with inline timer below */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', bottom: 6 }}>
                    <IconButton
                      onClick={!paused ? handlePauseClick : handleResume}
                      disabled={
                        !paused
                          ? stopped || !isRecording
                          : resumeWaitingForServer ||
                            ((!manualPause && !autoPaused) || (!isMicActive && !isSystemActive) || audioControlDisabled)
                      }
                      sx={{
                        width: 40,
                        height: 40,
                        bgcolor: 'primary.main',
                        color: 'white',
                        boxShadow: '0px 3px 8px rgba(0,0,0,0.2)',
                        '&:hover': { bgcolor: 'primary.dark' },
                        mb: 0.5,
                      }}
                    >
                      {!paused ? (
                        <PauseIcon sx={{ fontSize: 28, transform: 'rotate(180deg)' }} />
                      ) : resumeWaitingForServer ? (
                        <Box sx={{ display: 'inline-flex', width: 28, height: 28, alignItems: 'center', justifyContent: 'center' }}>
                          <CircularProgress size={24} color="inherit" sx={{ display: 'block' }} />
                        </Box>
                      ) : (
                        <PlayArrowIcon sx={{ fontSize: 30 }} />
                      )}
                    </IconButton>
                    <Typography
                      variant="body2"
                      sx={{
                        color: 'text.primary',
                        fontWeight: 600,
                        fontSize: '12px',
                        fontVariantNumeric: 'tabular-nums',
                        mt: 0.5,
                      }}
                    >
                      {props.formatTime ? props.formatTime(props.recordingTime) : '00:00:00'}
                    </Typography>
                  </Box>

                  {/* Stop */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                    <IconButton
                      onClick={handleStopClick}
                      disabled={!isRecording || currentMeetingDetails?.audioControlDisabled}
                      sx={{
                        bgcolor: '#ffcdd2',
                        color: '#d32f2f',
                        width: 40,
                        height: 40,
                        '&:hover': { bgcolor: '#ef9a9a' },
                      }}
                    >
                      <StopCircleIcon sx={{ fontSize: 20 }} />
                    </IconButton>
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, fontSize: '0.7rem' }}>
                      Stop
                    </Typography>
                  </Box>
                </>
              )}
            </Box>
          </Box>
        </Paper>
      )}
      {/* Popovers, Dialogs, etc. (Common to both views) */}
      <Popover
        id={popoverId}
        open={openPopover}
        anchorEl={micPopoverAnchor}
        onClose={handleMicPopoverClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        slotProps={{
          paper: {
            sx: {
              backgroundColor: '#3c4043',
              color: '#e8eaed',
              borderRadius: '12px',
              p: 2,
              mt: 1,
              width: '320px',
            },
          },
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {microphones.map(mic => (
            <Box
              key={mic.deviceId}
              onClick={() => {
                selectMicrophone(mic.deviceId);
                handleMicPopoverClose();
              }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                cursor: 'pointer',
              }}
            >
              {activeMicrophone?.deviceId === mic.deviceId && (
                <CheckIcon sx={{ color: '#8ab4f8' }} />
              )}
              <Box>
                <Typography
                  sx={{
                    color:
                      activeMicrophone?.deviceId === mic.deviceId
                        ? '#8ab4f8'
                        : '#e8eaed',
                    fontWeight: '500',
                  }}
                >
                  {mic.label || 'Unnamed Microphone'}
                </Typography>
                {activeMicrophone?.deviceId === mic.deviceId && (
                  <Typography variant="body2" sx={{ color: '#bdc1c6' }}>
                    System default
                  </Typography>
                )}
              </Box>
            </Box>
          ))}

          {activeMicrophone && (
            <Box
              sx={{ display: 'flex', alignItems: 'center', gap: 2, pl: '2px' }}
            >
              <MicIcon sx={{ color: '#e8eaed' }} className={isRecording ? 'recording' : ''} />
              <LinearProgress
                variant="determinate"
                value={volume}
                sx={{
                  flexGrow: 1,
                  height: 4,
                  borderRadius: 2,
                  backgroundColor: '#5f6368',
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: '#8ab4f8',
                  },
                }}
              />
            </Box>
          )}
        </Box>
      </Popover>
      {!isMobileView ? (
        <Dialog
          open={openShareDialog}
          onClose={handleShareDialogClose}
          maxWidth={false}
          PaperProps={{
            sx: {
              borderRadius: 2,
              width: 380,
              maxWidth: 'calc(100vw - 32px)',
            },
          }}
        >
          <DialogTitle sx={{ py: 1.5, px: 2 }}>
            <Box display="flex" alignItems="center" gap={1}>
              <LinkIcon sx={{ color: 'primary.main' }} />
              <Typography variant="h6" component="span" fontWeight={600}>
                Share link
              </Typography>
              <IconButton
                aria-label="close"
                onClick={handleShareDialogClose}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: 'text.secondary',
                }}
                size="small"
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ pt: 0, px: 2, pb: 2 }}>
            {isLoadingShare && !shareUrl ? (
              <Box display="flex" justifyContent="center" py={3}>
                <Typography variant="body2" color="text.secondary">
                  Loading share URL...
                </Typography>
              </Box>
            ) : shareUrl ? (
              <Stack spacing={0}>
                {/* URL + Copy row */}
                <Box>
        <Typography
          variant="caption"
          color="text.secondary"
          fontWeight={500}
          sx={{ mb: 1, display: 'block' }}
        >
          URL
        </Typography>
        <Box display="flex" gap={1}>
        <TextField
            fullWidth
            value={shareUrl}
            variant="outlined"
            size="small"
            sx={{ minWidth: 0 }}
            InputProps={{
              readOnly: true,
              sx: {
                backgroundColor: 'var(--grey-50)',
                fontSize: '14px',
                borderRadius: 1.5,
                '& fieldset': { borderRadius: 1.5 },
              },
            }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleCopyUrl}
            startIcon={<ContentCopyIcon />}
            sx={{
              '& .MuiButton-startIcon': {
                marginLeft: 0,
                marginRight: 0,
              },
            }}
          >
            {/* {copied ? 'Copied!' : 'Copy link'} */}
          </Button>
        </Box>
      </Box>

                {/* OR SHARE VIA separator */}
            
                <Box
            sx={{
              flex: 1,
              height: 1,
              marginTop: '12px',
             
            }}
          >
      <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
              fontWeight: 500,
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              marginBottom: '12px',
            }}
          >
            Share using
          </Typography>
                {/* Share via cards */}
                <Grid container spacing={1.5} display="flex" flexWrap="nowrap" marginTop="8px" >
          <Grid item xs={6} width={"100%"}>
            <WhatsappShareButton
              url={shareUrl}
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 6,
                padding: '12px',
                border: '1px solid var(--grey-100)',
                borderRadius: '8px',
                backgroundColor: 'transparent',
                cursor: 'pointer',
                textDecoration: 'none',
                transition: 'all 0.2s',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.backgroundColor =
                  'var(--grey-50)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
            >
              <WhatsAppIcon sx={{ fontSize: 28 }} />
              <Typography variant="body2" color="text.primary" fontWeight={500}>
                WhatsApp
              </Typography>
            </WhatsappShareButton>
          </Grid>
          <Grid item xs={6} width={"100%"}>
            <Box
              component="div"
              onClick={() => {
                window.location.href = gmailLink;
              }}
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 0.5,
                padding: '12px',
                border: '1px solid var(--grey-100)',
                borderRadius: '8px',
                backgroundColor: 'transparent',
                cursor: 'pointer',
                transition: 'all 0.2s',
                '&:hover': {
                  backgroundColor: 'var(--grey-50)',
                },
              }}
            >
              <GMailIcon sx={{ fontSize: 28, color: '#EA4335' }} />
              <Typography variant="body2" color="text.primary" fontWeight={500}>
                Email
              </Typography>
            </Box>
          </Grid>
          
          </Grid>
          </Box>
              </Stack>
            ) : (
              <Box display="flex" justifyContent="center" py={3}>
                <Typography variant="body2" color="text.secondary" align="center">
                  Unable to generate share URL. Please try again.
                </Typography>
              </Box>
            )}
          </DialogContent>
        </Dialog>
      ) : (
        <SwipeableDrawer
          anchor="bottom"
          open={openShareDialog}
          onClose={handleShareDialogClose}
          onOpen={() => { }}
          disableSwipeToOpen={true}
          PaperProps={{
            sx: {
              borderTopLeftRadius: '24px',
              borderTopRightRadius: '24px',
              paddingBottom: '24px',
              maxHeight: '90vh',
            },
          }}
        >
          {/* The "Puller" Bar - The grey line at the top */}
          <Box
            sx={{
              width: 40,
              height: 6,
              backgroundColor: 'grey.300',
              borderRadius: 3,
              position: 'absolute',
              top: 8,
              left: 'calc(50% - 20px)',
            }}
          />

          {/* Header Section */}
          <Box sx={{ padding: '24px 24px 16px 24px' }}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Box display="flex" alignItems="center" gap={1}>
                <LinkIcon sx={{ color: 'primary.main' }} />
                <Typography variant="h6" component="span" fontWeight={600}>
                  Share link
                </Typography>
              </Box>
              <IconButton
                aria-label="close"
                onClick={handleShareDialogClose}
                size="small"
                sx={{ color: 'text.secondary' }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>

          {/* Content Section */}
          <Box sx={{ padding: '0px 24px' }}>
            {isLoadingShare && !shareUrl ? (
              <Box display="flex" justifyContent="center" flexWrap={'wrap'} py={4}>
                <Typography variant="body2" color="text.secondary">
                  Loading share URL...
                </Typography>
              </Box>
            ) : shareUrl ? (
              <Stack spacing={3}>
                <Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    fontWeight={500}
                    sx={{ mb: 1, display: 'block' }}
                  >
                    URL
                  </Typography>
                  <Box display="flex" gap={1} flexWrap={'nowrap'}>
                    <TextField
                      fullWidth
                      value={shareUrl}
                      variant="outlined"
                      size="small"
                      InputProps={{
                        readOnly: true,
                        sx: {
                          backgroundColor: 'var(--grey-50)',
                          fontSize: '14px',
                        },
                      }}
                    />

                    <Tooltip title={copied ? "Copied!" : "Copy link"}>
                      <IconButton
                        size='small'
                        onClick={handleCopyUrl}
                        color="primary"
                        sx={{
                          border: '1px solid',
                          borderColor: 'bluegrey.500',
                          borderRadius: 1,

                        }}
                      >
                        <ContentCopyIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>

                {/* Social Icons Grid */}
                <Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    fontWeight={500}
                    sx={{ mb: 2, display: 'block' }}
                  >
                    Share using
                  </Typography>
                  <Grid container spacing={2} sx={{ alignItems: 'stretch' }}>
                    <Grid item xs={4} sm={3}>
                      <WhatsappShareButton
                        url={shareUrl}
                        style={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          gap: 8,
                          padding: '12px',
                          border: '1px solid var(--grey-100)',
                          borderRadius: '8px',
                          backgroundColor: 'transparent',
                          cursor: 'pointer',
                          textDecoration: 'none',
                          transition: 'all 0.2s',
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.backgroundColor =
                            'var(--grey-50)';
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.backgroundColor =
                            'transparent';
                        }}
                      >
                        <WhatsAppIcon sx={{ fontSize: 28 }} />
                        <Typography
                          variant="caption"
                          color="text.primary"
                        >
                          WhatsApp
                        </Typography>
                      </WhatsappShareButton>
                    </Grid>
                    <Grid item xs={4} sm={3}>
                      <Box
                        component="div"
                        onClick={() => {
                          window.location.href = gmailLink;
                        }}
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          gap: 1,
                          padding: '12px',
                          border: '1px solid var(--grey-100)',
                          borderRadius: '8px',
                          backgroundColor: 'transparent',
                          cursor: 'pointer',
                          width: '90px',
                          height: '86px',
                          transition: 'all 0.2s',
                          '&:hover': {
                            backgroundColor: 'var(--grey-50)',
                          },
                        }}
                      >
                        <GMailIcon
                          sx={{ fontSize: 28, color: '#EA4335' }}
                        />
                        <Typography
                          variant="caption"
                          color="text.primary"
                        >
                          Email
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Stack>
            ) : null}
          </Box>
        </SwipeableDrawer>
      )}
      <SummarizeDialog
        open={dialogOpen}
        meetingTitle={meetingTitle}
        meetingContext={meetingContext}
        setMeetingAPIDetails={props.setMeetingAPIDetails}
        isMeetingAPIData={Object.keys(props.meetingAPIDetails).length > 0}
        onClose={() => {
          if (dialogOpenedForStopRef.current) {
            dispatch(openSnackbar('info', 'Your last meeting was stopped.'));
          }
          dialogOpenedForStopRef.current = false;
          dispatch(setCurrentRecording({ lastAutoStopReason: null, isStarted: false }));
          setDialogOpen(false);
        }}
        onSubmit={async () => {
          // First generate MOM, then update title. Success snackbar "Meeting Summary generated successfully." is shown by handleSumbit in TranscriberDetail.
          dialogOpenedForStopRef.current = false;
          await props.handleSumbit(setDialogOpen);
          await props.handleTitleUpdate(meetingTitleRef);
          dispatch(setCurrentRecording({ lastAutoStopReason: null, isStarted: false }));
        }}
        loading={props.loading}
      />
      <Dialog
        open={resumeDialogOpen}
        onClose={() => setResumeDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Typography
            variant="subtitle1"
            component={'span'}
            color="text.primary"
          >
            Are you sure you want to continue?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.primary">
            This will start a new meeting from where you left off.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setResumeDialogOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={async () => {
              // Verify mic permission before starting the resume flow.
              // Without mic access the WebSocket would connect but nothing
              // useful can happen, leaving the user in a broken state.
              try {
                const permResult = await navigator.permissions.query({ name: 'microphone' });
                if (permResult.state === 'denied') {
                  setResumeDialogOpen(false);
                  dispatch(
                    openSnackbar(
                      'error',
                      'Please allow Microphone access to run Genie Transcribe.',
                      true,
                      6000
                    )
                  );
                  return;
                }
              } catch (_) {
                // Permissions API not supported — continue and let getUserMedia handle it
              }

              props.resetAll();
              props.setLoading(true);
              if (props.setMeetingAPIDetails) {
                props.setMeetingAPIDetails({});
              }
              props.setDetails(prev => ({
                ...prev,
                meetingDetails: {
                  ...(prev?.meetingDetails || {}),
                  id: prev?.meetingDetails?.id || currentRecordingId,
                  title: prev?.meetingDetails?.title || currentRecordingTitle,
                },
                isResume: true,
                isDetailsView: false,
              }));
              navigate(ROUTES.HOME);
              setResumeDialogOpen(false);
            }}
          >
            Resume
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDeleteDialogue}
        onClose={() => setOpenDeleteDialogue(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Typography
            variant="subtitle1"
            component={'span'}
            color="text.primary"
          >
            Are you sure you want to continue?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.primary">
            {/* {`${meeting?.title} will be deleted.`} */}
            {
              <>
                <strong>{currentRecordingTitle}</strong> will be
                deleted.
              </>
            }
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenDeleteDialogue(false);
            }}
          >
            Cancel
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={() => {
              handleSoftDelete(currentRecordingId);
              setOpenDeleteDialogue(false);
            }}
            disabled={!currentRecordingId}
          >
            DELETE
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openRestoreDialog}
        onClose={() => setOpenRestoreDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Typography
            variant="subtitle1"
            component={'span'}
            color="text.primary"
          >
            Restore this meeting?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.primary">
            <strong>{currentRecordingTitle}</strong> will be
            restored to your history.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenRestoreDialog(false)}>Cancel</Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              handleRestore(currentRecordingId);
              setOpenRestoreDialog(false);
            }}
            disabled={!currentRecordingId}
          >
            Restore
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openPermanentDeleteDialog}
        onClose={() => setOpenPermanentDeleteDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Typography
            variant="subtitle1"
            component={'span'}
            color="text.primary"
          >
            Permanently delete this meeting?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.primary">
            <strong>{currentRecordingTitle}</strong> will be
            permanently deleted. This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPermanentDeleteDialog(false)}>
            Cancel
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={() => {
              handlePermanentDelete(currentRecordingId);
              setOpenPermanentDeleteDialog(false);
            }}
            disabled={!currentRecordingId}
          >
            Permanently Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={lastSourceDialogOpen}
        onClose={handleLastSourceCancel}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Typography variant="subtitle1" fontWeight={600}>
            Pause Meeting?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.primary">
            Disabling the last audio source will pause the meeting. Do you want
            to continue?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLastSourceCancel}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleLastSourceProceed}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default AudioControl;
